export default __webpack_public_path__ + "static/media/sendMail.113eb81d.svg";